import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DateTimeRange from "../../components/common/DateTimeRange";
import { useAuth } from "../../Context/AuthProvider";
import axios from "axios";
import { url } from "../../Constant";
import { toast } from "react-toastify";
import { checkIndividualPermission } from "../../Utils/PermissionFunctions";
import { Space, TimePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import { id } from "date-fns/locale";

const UploadCampaign = () => {
  const { auth } = useAuth();
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [fileUploadError, setFileUploadError] = useState("");
  const [submittedData, setSubmittedData] = useState({
    csv_file: "",
    CampaignName: "",
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    vpbx_id: auth.vpbx_id,
    template_name: auth.template_name,
  });
  const handleFile = (e) => {
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    if (fileExtensionName !== "csv") {
      setFileUploadError("Please upload csv format file");
      setSubmittedData({
        ...submittedData,
        csv_file: "Invalid File",
      });
    } else {
      setFileUploadError("");
      setSubmittedData({
        ...submittedData,
        csv_file: file,
      });
    }
  };
  const createCampagin = () => {
    // e.preventDefault();

    setErrorEnable(true);
    setLoader(true);

    var formData = new FormData();

    formData.append("vpbx_id", submittedData.vpbx_id);
    formData.append("csv_file", submittedData.csv_file);

    formData.append("campaign_name", submittedData.CampaignName);
    formData.append("start_date", submittedData.startDate);
    formData.append("start_time", submittedData.startTime);
    formData.append("end_date", submittedData.endDate);
    formData.append("end_time", submittedData.endTime);

    if (fileUploadError === "" && submittedData.csv_file !== "") {
      axios
        .post(url + "create-campaign", formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.data.code === 400) {
              toast.error(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setLoader(false);
            } else {
              setLoader(false);
              toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setTimeout(() => {
                window.location.href = "/call-initialize";
              }, 2000);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };

  const [showDateTimeInputs, setShowDateTimeInputs] = useState(false);
  const [startTimeDisabled, setStartTimeDisabled] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endTimeDisabled, setEndTimeDisabled] = useState(true);
  const [endDate, setEndDate] = useState("");

  const [selectedTime, setSelectedTime] = useState(moment());

  const handleTimeChange = (e, date) => {
    if (date === "start") {
      setSubmittedData({
        ...submittedData,
        startTime: moment(e.$d).format("HH:mm"),
      });
    } else {
      setSubmittedData({
        ...submittedData,
        endTime: moment(e.$d).format("HH:mm"),
      });
    }
  };

  const handleSelectChange = (e) => {
    setShowDateTimeInputs(e.target.value === "Schedule");
  };

  const handleStartDateChange = (e) => {
    const startDateValue = e.target.value;
    setSubmittedData({
      ...submittedData,
      startDate: startDateValue,
    });
    setStartDate(startDateValue);
    setStartTimeDisabled(false); // Enable the start time input when a start date is selected
  };

  const handleEndDateChange = (e) => {
    const endDateValue = e.target.value;
    setSubmittedData({
      ...submittedData,
      endDate: endDateValue,
    });
    setEndDate(endDateValue);
    setEndTimeDisabled(false); // Enable the end time input when an end date is selected
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/call-initialize">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to Call Initialize</span>
                </Link>
                <h3>Create Campagin</h3>
                {/* <p>Provide the necessary details to create a new IVR flow.</p> */}
              </div>
            </div>
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Campaign Name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Campaign Name"
                    aria-label="Input"
                    // value={submittedData.CampaignName}
                    onChange={(e) =>
                      setSubmittedData({
                        ...submittedData,
                        CampaignName: e.target.value,
                      })
                    }
                  />
                  {errorEnable && submittedData.CampaignName === "" && (
                    <div className="formErrors">Please enter Campaign Name</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>
                    <b>Upload Campaign file</b>
                  </label>

                  <div className="uk-margin-bottom">
                    <div
                      uk-form-custom="target: true"
                      style={{ width: "100%" }}
                    >
                      <input
                        type="file"
                        aria-label="Custom controls"
                        accept=".csv"
                        onChange={(e) => handleFile(e)}
                        style={{ width: "100%" }}
                      />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                        style={{ width: "100%" }}
                      />
                      {errorEnable && submittedData.csv_file === "" && (
                        <div className="formErrors">Please upload file</div>
                      )}
                      {errorEnable && fileUploadError !== "" && (
                        <div className="formErrors">{fileUploadError}</div>
                      )}
                    </div>
                  </div>
                  {/* <a
                    href={
                      "https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/default.zip"
                    }
                    className="DownloadFileBtn"
                  >
                    Download sample file
                  </a> */}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Select Options</label>
                  <select
                    style={{ height: "40px", width: "100%", padding: "5px" }}
                    onChange={handleSelectChange}
                  >
                    <option value="Now">Now</option>
                    <option value="Schedule">Schedule</option>
                  </select>
                </div>

                <div className="uk-width-1-2@m uk-margin-top"></div>

                {showDateTimeInputs && (
                  <>
                    <div className="uk-width-1-4@m uk-margin-top">
                      <label>Start Date</label>
                      <input
                        className="uk-input"
                        type="date"
                        placeholder="Campaign Name"
                        aria-label="Input"
                        onChange={handleStartDateChange}
                        required
                        min={new Date().toISOString().split("T")[0]}
                      />
                    </div>

                    <div className="uk-width-1-4@m uk-margin-top">
                      <div className="startTimeInput">
                        <label>Start time</label>
                        <Space wrap>
                          <TimePicker
                            format={"HH:mm"}
                            disabled={startTimeDisabled}
                            //  defaultValue={moment()}
                            // value={selectedTime} // Here's where we bind the selectedTime state to the value of the TimePicker
                            onChange={(e) => handleTimeChange(e, "start")}
                            required
                          />
                        </Space>
                      </div>
                    </div>

                    <div className="uk-width-1-4@m uk-margin-top">
                      <label>End Date</label>
                      <input
                        className="uk-input"
                        type="date"
                        placeholder="Campaign Name"
                        aria-label="Input"
                        onChange={handleEndDateChange}
                        required
                        min={new Date().toISOString().split("T")[0]}
                      />
                    </div>

                    <div className="uk-width-1-4@m uk-margin-top">
                      <div className="startTimeInput">
                        <label>End time</label>
                        <Space wrap>
                          <TimePicker
                            format={"HH:mm"}
                            disabled={endTimeDisabled}
                            // defaultValue={moment()}
                            onChange={(e) => handleTimeChange(e, "end")}
                            required
                          />
                        </Space>
                      </div>
                    </div>
                  </>
                )}

                {(auth.role === "2" ||
                  (auth.role === "3" &&
                    checkIndividualPermission(
                      "ivr-flow",
                      "read_and_write"
                    ))) && (
                  <div className="uk-width-1-1@m uk-float-right">
                    <div
                      className="formActionBtn uk-text-right"
                      style={{ "margin-top": "20px" }}
                    >
                      {/* <button className="whiteBtn">Cancel</button> */}
                      <button
                        className="pinkBtn"
                        onClick={() => createCampagin()}
                      >
                        {loader ? (
                          <div uk-spinner="" className="loader">
                            Adding
                          </div>
                        ) : (
                          "Create"
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UploadCampaign;
